import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Grid,
} from "@mui/material";
import { useServiceInscripcionCursos } from "hooks/inscripcionCursos/useInscripcionCursos";
import moment from "moment";
import { useEffect, useState } from "react";

export const CardsCursos = () => {
  const { lstCursos, enviado, setCursoSeleccionado } =
    useServiceInscripcionCursos();
  const [cursoSelected, setCursoSelected] = useState<number | null>(null);

  useEffect(() => {
    if (cursoSelected) {
      setCursoSeleccionado(cursoSelected);
    }
  }, [cursoSelected]);

  useEffect(() => {
    if (enviado) {
      setCursoSelected(null);
    }
  }, [enviado]);

  const headerCurso = (curso: any) => {
    const isChecked = cursoSelected === curso?.idcursotribunal;
    return (
      <div className="flex flex-row gap-2 justify-center items-center">
        <span className="text-sm font-semibold text-gray-700">
          <strong>{curso?.titulo?.toUpperCase()}</strong>
        </span>

        <Checkbox
          checked={isChecked}
          className="cursor-pointer"
          style={{ color: "#265ab4" }}
          disabled={curso?.inscrito === true ? true : false}
          value={curso?.idcursotribunal}
          onChange={() => {
            setCursoSelected(isChecked ? null : curso?.idcursotribunal);
          }}
        />
      </div>
    );
  };

  return (
    <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="mx-auto mt-4">
      {lstCursos.length > 0 ? (
        <>
          <div className="flex flex-row flex-wrap gap-4 justify-center">
            {lstCursos?.map((curso: any) => (
              <Card key={curso?.idcursotribunal}>
                <CardHeader
                  title={headerCurso(curso)}
                  style={{ backgroundColor: "#b9e4f2" }}
                />
                <Divider />
                <CardContent>
                  <div className="flex flex-col gap-2">
                    <div className="flex flex-row gap-2 items-center">
                      <span className="text-sm font-semibold text-gray-700">
                        Fecha de Inicio :
                        {moment(curso?.fechaInicio).format("DD/MM/YYYY")}
                      </span>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                      <span className="text-sm font-semibold text-gray-700">
                        Horario : {curso?.horaInicio} - {curso?.horaFin}
                      </span>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                      <span className="text-sm font-semibold text-gray-700">
                        Capacitador : {curso?.capacitador}
                      </span>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                      <span className="text-sm font-semibold text-gray-700">
                        Cupo : {curso?.limiteAsistentes}
                      </span>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                      <span className="text-sm font-semibold text-gray-700">
                        Lugares disponibles:{" "}
                        {curso?.limiteAsistentes - curso?.inscripciones?.length}
                      </span>
                    </div>
                    <div
                      className={
                        Number(curso?.limiteAsistentes) -
                          curso?.inscripciones?.length ===
                        0
                          ? "flex flex-row gap-2 items-center"
                          : "hidden "
                      }
                    >
                      <span
                        className="text-sm font-semibold text-gray-700"
                        style={{ color: "red" }}
                      >
                        EL CURSO ESTA LLENO
                      </span>
                    </div>
                    <div
                      className={
                        curso?.inscrito === true
                          ? "flex flex-row gap-2 items-center"
                          : "hidden "
                      }
                    >
                      <span
                        className="text-sm font-semibold text-gray-700"
                        style={{ color: "red" }}
                      >
                        YA ESTAS INSCRITO EN ESTE CURSO
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </>
      ) : null}
    </Grid>
  );
};
